/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 2a9 9 0 100 18 9 9 0 000-18zm0 12.998a1 1 0 110 2 1 1 0 010-2zm1.004-10v8h-2.001v-8h2z" _fill="#EF4136" fill-rule="evenodd"/>'
  }
})
